import axios from 'axios';
import * as cookieServices from 'services/cookies/cookieServices';
import * as settings from 'settings/settings';
import * as miscServices from 'services/miscServices';

export function getBase64Credentials() {
    /*
        spedisco le credenziali di calamp al servizio di export insu che eseguirà una nuova login.
        le credenziali vengono encodate in formato base64
    */

    const dataSeparator = "§";

    var appData = cookieServices.getAppCookie();
    if(!appData) return null;

    var combination = appData.username + miscServices.charToAscii(dataSeparator) + appData.pwd +
        miscServices.charToAscii(dataSeparator) + appData.key +
        miscServices.charToAscii(dataSeparator) + appData.baseUri;
    return btoa(combination);
}

export function getInstance(){

    var instance = axios.create({
        baseURL: settings.crashBoxxWebApiBaseUri,
        headers: {
            'Accept': 'application/json',
            'Accept-Language': cookieServices.getLanguageCode(),
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': 'Basic ' + getBase64Credentials()
            },
        crossdomain: true,
        withCredentials: true,
        xhrFields: {
            'withCredentials': 'true'
        }
      });

      return instance;
}



// WEBPACK FOOTER //
// ./src/services/apis/crashboxx/httpHolder.js